import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Projects API
export const projectsApi = {
  getAll: (archived = false) => api.get(`/projects?archived=${archived}`),
  getOne: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
  archive: (id) => api.post(`/projects/${id}/archive`),
  unarchive: (id) => api.post(`/projects/${id}/unarchive`),
  promote: (id) => api.post(`/projects/${id}/promote`),
  uploadPhoto: (projectId, file, caption = '') => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/projects/${projectId}/photos?caption=${encodeURIComponent(caption)}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deletePhoto: (projectId, photoId) => api.delete(`/projects/${projectId}/photos/${photoId}`),
  updatePhotoCaption: (projectId, photoId, caption) => 
    api.put(`/projects/${projectId}/photos/${photoId}/caption`, { caption }),
  uploadFile: (projectId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/projects/${projectId}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteFile: (projectId, fileId) => api.delete(`/projects/${projectId}/files/${fileId}`),
};

// Messages API
export const messagesApi = {
  getConversations: () => api.get('/messages/conversations'),
  getMessages: (userId) => api.get(`/messages/${userId}`),
  send: (data) => api.post('/messages', data),
  getUnreadCount: () => api.get('/messages/unread/count'),
};

// Users API
export const usersApi = {
  getAll: () => api.get('/users'),
};

// Calendar API
export const calendarApi = {
  getEvents: () => api.get('/calendar/events'),
  createEvent: (data) => api.post('/calendar/events', data),
  deleteEvent: (id) => api.delete(`/calendar/events/${id}`),
};

// Resources API
export const resourcesApi = {
  getAll: () => api.get('/resources'),
  createBookmark: (data) => api.post('/resources/bookmarks', data),
  deleteBookmark: (id) => api.delete(`/resources/bookmarks/${id}`),
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/resources/files', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteFile: (id) => api.delete(`/resources/files/${id}`),
};

// Supplies API (shared across all users)
export const suppliesApi = {
  getAll: () => api.get('/supplies'),
  create: (data) => api.post('/supplies', data),
  update: (id, data) => api.put(`/supplies/${id}`, data),
  delete: (id) => api.delete(`/supplies/${id}`),
};

export const getFileUrl = (storagePath) => {
  return `${API_URL}/api/files/${storagePath}`;
};

export default api;
